export const patientRouteDef = [
    // {
    //     path:'custom_component',
    //     component:AppResourcePermissionComponent
    // }
    {
        path: 'uploadedfile_metadata',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine',
            resource: 'uploadedfile_metadata_tab',
            action: 'IMAGE_VIEWER',
        }
    },
    {
        path:':resource/add_new_patient',
        component:'ExtendedSearchComponentComponent',
        data: {
            selector: "kx-extended-search-component",
            resource: "add_ivf_patient",
            action: 'LIST'
        },
    },
   
    {
        path:':resource/tab',
        component:'UiEngineComponent',
        data : {
            selector: 'app-ui-engine',
            resource: 'family_member_detail_tab',
        }
    },
    {
        path: 'patient-bot',
        component:'PatientBotComponent',
        data : {
            selector: 'app-patient-bot'
        }
    },
    {
        path: ':resource/:id/patient-profile',
        component: 'ProfileComponent',
        data: {
            selector: 'kx-profile'
        }
    },
    {
        path: ':resource/:id/modify',
        component: 'UiEngineComponent',
        data: {
            selector: 'app-ui-engine'
        }
    }

]    